import { ApplicationConfig, LOCALE_ID, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideToastr } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoaderInterceptor } from './core/interceptors/loader.interceptors';
import { ApiInterceptor } from './core/interceptors/api.interceptor';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter, provideNativeDateAdapter } from '@angular/material/core';
import { MAT_DIALOG_SCROLL_STRATEGY } from '@angular/material/dialog';
import { Overlay,OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './shared/components/custom-overlay-container';
import { RuntimeConfigService } from './core/config/runtime-config.service';

registerLocaleData(localeDe);

export function scrollStrategyFactory(overlay: Overlay) {
  return () => overlay.scrollStrategies.reposition();
}
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY HH:mm',
  },
  display: {
    dateInput: 'DD/MM/YYYY HH:mm',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export const appConfig: ApplicationConfig = {
  providers: [   
    provideAppInitializer(() => {
      const runtimeConfig = inject(RuntimeConfigService);
      return runtimeConfig.load();
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
      progressBar: true,
    }),
    provideHttpClient(withInterceptorsFromDi()), // ✅ Ensure this is before interceptors
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: OverlayContainer, useClass: CustomOverlayContainer,},
    provideAnimations(),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslateHttpLoader(http, './assets/data/', '.json'),
        deps: [HttpClient],
      },
    }),
    MatDatepickerModule,  
    provideNativeDateAdapter(),
    {provide: DateAdapter, useClass: NativeDateAdapter, deps: [MAT_DATE_LOCALE]},
    {
      provide: MAT_DIALOG_SCROLL_STRATEGY,
      useFactory: scrollStrategyFactory,
      deps: [Overlay]
    },
     { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // dd/MM/yyyy instead of MM/dd/yyyy
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }

  ],
};
